/*
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2022-05-06 17:11:40
 * @LastEditors: wangcan
 * @LastEditTime: 2023-03-30 17:35:36
 */
import axios from 'axios'
// import store from '@/store'
import {
  loginMobile
} from '@/utils'
import cookies from 'vue-cookies'
const service = axios.create({
  // baseURL: process.env.NODE_ENV != 'production' ?process.env.VUE_APP_BASEURL:window.SITE_CONFIG.baseUrl,http://192.168.9.184:7010/mhys/http://192.168.6.138:7010/mhys
  baseURL: process.env.NODE_ENV != 'production' ?"/proxyApi":window.SITE_CONFIG.base_url,
  timeout: 180 * 1000,
  isRetryRequest: false
})
// 请求拦截
service.interceptors.request.use(
  config => {
    // if (store.getters.apiToken) {
    //   config.headers['apiToken'] = store.getters.apiToken;
    // }
    config.headers['apiToken'] = cookies.get('apiToken')
    if (config.method === 'get') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.params = {
        t: Date.now(),
        ...config.params,
      };
    } else {
    console.log('application/json');
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  error => {
    // this.$message({
    //   message: response.data.msg,
    //   type: 'error'
    // })
    Promise.reject(error)
  }
)
/**
 * 响应拦截
 */
service.interceptors.response.use(response => {
  if (response.data && response.data.code !== 200) {
    if (response.data && response.data.code === 402) { // 402, token失效
      loginMobile();
    }
    if (response.data.msg) {
      // this.$message({
      //   message: response.data.msg,
      //   type: 'error'
      // })
    }
  }
  return response
}, error => {
  return Promise.reject(error)
})
export default service